<template>
  <div id="contact" class="screen">
    <Title content="kontakt" color="white"/>
    <div id="contact-grid-container">
      <BasicInformation :content="contactData"/>
      <GoogleMap />
      <ContactForm />
    </div>
  </div>
</template>

<script>
import BasicInformation from '@/components/ContactScreen/BasicInformation.vue';
import GoogleMap from '@/components/ContactScreen/GoogleMap.vue';
import ContactForm from '@/components/ContactScreen/ContactForm.vue';
import Title from '@/components/Title.vue';

export default {
  name: 'ContactScreenContainer',
  components: {
    BasicInformation,
    GoogleMap,
    ContactForm,
    Title,
  },
  props: {
    contactData: Object,
  },
};
</script>

<style scoped lang="scss">
  #contact { background-color: #414141; @media (min-width: 992px) { padding: 50px 150px }}

  #contact-grid-container {
    @media (min-width: 992px) {
      position: relative;

      display: grid;
      grid-gap: 25px;
      grid-template: "basic contact" 300px "maps contact" 300px / 50% 50%;
    }

    @media (min-width: 1200px) {
      grid-template: "basic contact" 300px "maps contact" 400px / 50% 50%;

      $width: 1200px;
      width: $width;
      left: calc(50% - calc(#{$width} / 2));
    }
  }
</style>
